import actiontypes from "./actiontypes";

export const setFilters = filters => {
  return {
    type: actiontypes.SET_FILTERS,
    payload: filters
  };
};

export const setActiveInstitution = id => {
  return {
    type: actiontypes.SET_ACTIVE_INSTITUTION,
    payload: id
  };
};

export const toggleNav = () => {
  return {
    type: actiontypes.TOGGLE_NAV
  };
};

export const closeNav = () => {
  return {
    type: actiontypes.CLOSE_NAV
  };
};

export const loadCategories = () => {
  return {
    type: actiontypes.LOAD_CATEGORIES
  };
};

export const loadDistricts = () => {
  return {
    type: actiontypes.LOAD_DISTRICTS
  };
};

export const loadInstitutions = () => {
  return {
    type: actiontypes.LOAD_INSTITUTIONS
  };
};

export const fetchInstitution = key => {
  return {
    type: actiontypes.FETCH_INSTITUTION,
    payload: key
  };
};

export const clearEditInstitution = () => {
  return {
    type: actiontypes.CLEAR_EDIT_INSTITUTION
  };
};

export const clearEditUser = () => {
  return {
    type: actiontypes.CLEAR_EDIT_USER
  };
};

export const validateRegistration = hash => {
  return {
    type: actiontypes.VALIDATE_REGISTRATION,
    payload: hash
  };
};

export const fetchingInstitution = key => {
  return {
    type: actiontypes.FETCHING_INSTITUTION,
    payload: key
  };
};

export const fetchedInstitution = institution => {
  return {
    type: actiontypes.FETCHED_INSTITUTION,
    payload: institution
  };
};

export const fetchInstitutions = params => {
  return {
    type: actiontypes.FETCH_INSTITUTIONS,
    payload: params
  };
};

export const fetchedInstitutions = params => {
  return {
    type: actiontypes.FETCHED_INSTITUTIONS,
    payload: params
  };
};

export const fetchingInstitutions = () => {
  return {
    type: actiontypes.FETCHING_INSTITUTIONS
  };
};

export const fetchUsers = () => {
  return {
    type: actiontypes.FETCH_USERS
  };
};

export const fetchUser = () => {
  return {
    type: actiontypes.FETCH_USER
  };
};

export const login = (username, password) => {
  return {
    type: actiontypes.LOGIN,
    payload: { username, password }
  };
};

export const logout = () => {
  return {
    type: actiontypes.LOGOUT
  };
};

export const saveUser = data => {
  return {
    type: actiontypes.SAVE_USER,
    payload: data
  };
};

export const editInstitution = key => {
  return {
    type: actiontypes.EDIT_INSTITUTION,
    payload: key
  };
};

export const saveInstitution = data => {
  return {
    type: actiontypes.SAVE_INSTITUTION,
    payload: data
  };
};

export const requestPassword = email => {
  return {
    type: actiontypes.REQUEST_PASSWORD,
    payload: email
  };
};

export const resetRequestPassword = () => {
  return {
    type: actiontypes.RESET_REQUEST_PASSWORD
  };
};

export const resetResetPassword = () => {
  return {
    type: actiontypes.RESET_RESET_PASSWORD
  };
};

export const resetPassword = (password1, password2, token) => {
  return {
    type: actiontypes.RESET_PASSWORD,
    payload: {
      password1,
      password2,
      token
    }
  };
};

export const loadUser = () => {
  return {
    type: actiontypes.LOAD_USER
  };
};



/** WEBPACK FOOTER **
 ** ./src/actions.js
 **/